import { LoadingButton } from '@mui/lab';
import { Box, InputBase, Stack, styled } from '@mui/material';
import palette from '../../theme/palette';
import Iconify from '../Iconify';

// export const GradientBorderWrapper = styled(Box)({
//   fontWeight: 700,
//   backgroundColor: 'transparent',
//   background:
//     'linear-gradient(0deg, rgba(0,0,0,1) 0%, rgba(56,56,56,1) 35%, rgba(56,56,56,1) 65%, rgba(0,0,0,1) 100%)',
//   color: 'white',
//   border: '2px solid transparent',
//   backgroundClip: 'padding-box',
//   position: 'relative',
//   '&:before': {
//     content: '""',
//     position: 'absolute',
//     top: 0,
//     right: 0,
//     left: 0,
//     bottom: 0,
//     zIndex: -1,
//     margin: '-2px',
//     borderRadius: 'inherit',
//     background:
//       'linear-gradient(90deg, rgba(196,150,59,1) 0%, rgba(221,198,116,1) 25%, rgba(221,198,116,1) 45%, rgba(191,149,59,1) 100%)',
//   },
// });

export const ThemeButton = styled(LoadingButton)(({ theme }) => ({
  width: '100%',
  background: palette.visitor.register.buttonBg,
  // border: `2px solid ${palette.visitor.register.border}`,
  color: `${palette.visitor.register.color} !important`,
  '&:disabled': {
    filter: 'grayscale(0.8)',
  },
}));

export const StyledIconify = styled(Iconify)(({ theme }) => ({
  height: 24,
  width: 24,
  color: palette.visitor.icon,
}));

export const InputContainer = styled(Stack)(({ theme }) => ({
  alignItems: 'center',
  borderRadius: '5px',
  height: '44px',
  padding: '8.5px 13px',
  background: 'linear-gradient(0deg, #C4C4C4, #FCFCFC, #D2D2D2)',
}));

export const InputBorder = styled('div')(() => ({
  height: 'fit-content',
  position: 'relative',
  padding: 2,
  flex: 1,
  borderRadius: '8px',
  background: `linear-gradient(90deg, #BC8001 0%, #C8941C 17.62%, #FAEB9A 26.88%, #C8941C 32.84%, #C8941C 38.5%, #FAEB9A 43.4%, #FAEB9A 52.96%, #C8941C 59.75%, #C8941C 63.11%, #FAEB9A 72.02%, #C8941C 79.16%, #BC8001 100%)`,
}));

export const StyledInput = styled(InputBase)(({ theme }) => ({
  marginLeft: 8,
  fontSize: '15px',
  fontWeight: 400,
  fontFamily: 'sans-serif',
  flexGrow: 1,
  color: palette.visitor.input.color,
  input: {
    fontSize: 14,
    color: palette.visitor.input.color,
    '&::placeholder': {
      opacity: 1,
      color: palette.visitor.input.placeholder,
    },
  },
}));

export const GradientBorderWrapper = ({ children, wrapperProps = {}, sx = {}, ...others }) => (
  <Box
    {...wrapperProps}
    sx={{
      padding: '2px',
      border: '1px solid gold',
      borderRadius: 1,
      background: 'linear-gradient(0deg, #C4C4C4 0%, #FCFCFC 51.95%, #D2D2D2 100%)',
      boxShadow: '0px 2px 6px 0px #000000B2',
      ...(wrapperProps?.sx || {}),
    }}
  >
    <Box
      sx={{
        borderRadius: 'inherit',
        ...sx,
      }}
      {...others}
    >
      {children}
    </Box>
  </Box>
);

export const GoldBorderButton = ({ children, sx = {}, wrapperSx = {}, wrapperProps = {}, ...others }) => (
  <Box
    sx={{
      background:
        'linear-gradient(90deg, #FFFAA8 0%, #FEF7AA 25.52%, #F0C91A 34.85%, #FFFAB3 42.93%, #FEF8AD 53.2%, #F1CA1A 62.03%, #FFFAB3 71.37%, #FFFAA8 100%)',
      padding: '1px',
      borderRadius: 1,
      border: 'none',
      ...wrapperSx,
    }}
    {...wrapperProps}
  >
    <LoadingButton
      sx={{
        fontWeight: 700,
        backgroundColor: 'transparent',
        backgroundImage: 'linear-gradient(90deg, #F00101 0%, #9F0101 100%)',
        color: 'white',
        borderRadius: 'inherit',
        ...sx,
      }}
      {...others}
    >
      {children}
    </LoadingButton>
  </Box>
);

export const ShiningGoldBorder = styled('div')(() => ({
  height: 'fit-content',
  position: 'relative',
  padding: 2,
  flex: 1,
  borderRadius: '8px',
  background: `linear-gradient(90deg, #BC8001 0%, #C8941C 17.62%, #FAEB9A 26.88%, #C8941C 32.84%, #C8941C 38.5%, #FAEB9A 43.4%, #FAEB9A 52.96%, #C8941C 59.75%, #C8941C 63.11%, #FAEB9A 72.02%, #C8941C 79.16%, #BC8001 100%)`,
}));
